(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const target = event.target;

    // Defer so this never competes with interaction paint (INP).
    setTimeout(() => {
      if (!document.querySelector('details[data-auto-close-details][open]')) return;

      const detailsToClose = document.querySelectorAll('details[data-auto-close-details][open]');
      const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';

      for (const element of detailsToClose) {
        if (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(target instanceof Node && element.contains(target))
        ) {
          element.removeAttribute('open');
        }
      }
    }, 0);
  });
})();
